<template>
  <table class="table">
    <thead>
      <tr>
        <th v-for="column in columns" :key="column">{{ column }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in data" :key="item._id" @click="selectDriver(item.fleet_id)">
        <td class="link-style">{{ item.name }}</td>
        <td class="link-style">{{ item.fleet_id }}</td>
        <td class="link-style">{{ item.tags }}</td>
        <td class="link-style">{{ item.team_id }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    props: {
      columns: Array,
      data: Array,
    },
    methods: {
      selectDriver(fleet_id) {
        this.$emit('selectDriver', fleet_id)
      }
    }
  }
</script>
<style>
.link-style {
  cursor: pointer; /* Changes cursor to hand symbol */
}
</style>
